var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"q-pa-sm full-height ops-personal-deploy-form"},[_c('rs-form',{ref:"form",attrs:{"name":"ten-deploy"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }